<template>
  <div class="portlet_wrapper">
    <div class="cnt_block">
      <div class="search">
        <div class="search_block">
          <label>學年期：</label>
          <select v-model="searchYear" @change="internSearch" style="min-width: 174px;">
            <option value="all">全部</option>
            <option v-for="tr in yearOptions">{{ tr }}</option>
          </select>
        </div>
        <div class="search_block">
          <label>公司名稱：</label>
          <select v-model="searchEnterprise" @change="internSearch" style="min-width: 193px;">
            <option value="all">全部</option>
            <option v-for="tr in enterpriseOptions" :value="tr.enterprise_id">{{ tr.enterprise_name }}</option>
          </select>
        </div>
        <div class="search_block">
          <label>學生：</label>
          <select v-model="searchStudent" @change="internSearch" style="min-width: 174px;">
            <option value="all">全部</option>
            <option v-for="tr in studentOptions" :value="tr.student_id">{{ tr.student_name }}</option>
          </select>
        </div>
      </div>
      <div class="table_holder">
        <table>
          <thead>
            <tr> <th>學年期</th> <th>公司名稱</th> <th>學生就讀系所</th> <th>學號</th> <th>姓名</th> <th>問題回報</th> <th>實習紀錄</th> </tr>
          </thead>
          <tbody>
            <tr v-for="tr in currentInternRecordListGetter">
              <td>{{ tr.year }}</td>
              <td>{{ tr.enterprise_name }}</td>
              <td>{{ tr.department }}</td>
              <td>{{ tr.student_account }}</td>
              <td>{{ tr.student_name }}</td>
              <td>
                <button
                  class="icon_btn chat_btn"
                  :data-id="tr.student_id"
                  @click="open_chat_room(tr.student_id)">
                </button>
              </td>
              <td>
                <router-link class="d-inline-block btn--pill pill blue"
                  :to="`/teachers/intern-record/${tr.year}/${tr.enterprise_id}/${tr.student_id}`"
                >實習紀錄</router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div id="new_chat_room"></div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { chat_room } from '~components/common/chat_room.js'
import '~style/components/chat_room.css'
export default {
  name: 'InternStudentsList',
  components: {
  },
  computed: {
    ...mapGetters('auth', [
      'tokenGetters'
    ]),
    ...mapGetters('pages/teachers', [
      'currentInternSearchOptionsGetter',
      'currentInternRecordListGetter',
      'currentTeacherGetter',
    ]),
    yearOptions() {
      return this.currentInternSearchOptionsGetter.year || [];
    },
    enterpriseOptions() {
      return this.currentInternSearchOptionsGetter.enterprise || [];
    },
    studentOptions() {
      return this.currentInternSearchOptionsGetter.student || [];
    },
  },
  data () {
    return {
      chat_room: null,
      searchYear: 'all',
      searchEnterprise: 'all',
      searchStudent: 'all',
    };
  },
  async created () {
    this.togglePageLoader(true);
    await this.getInternSearchOptions();
    await this.getInternRecordList({});
    await this.getTeacherByToken();
    this.togglePageLoader(false);
  },
  mounted () {
    let el = $('#new_chat_room')[0];
    this.chat_room = new chat_room(el, {
      name: this.currentTeacherGetter.teacher_name,
      token: this.tokenGetters,
    });
  },
  methods: {
    ...mapActions('pages/teachers', [
      'getInternSearchOptions',
      'getInternRecordList',
      'getTeacherByToken',
    ]),
    ...mapActions('layouts', [
      'togglePageLoader'
    ]),
    internSearch () {
      let search_data = {};
      if(this.searchYear != 'all') {
        search_data.year = this.searchYear;
      }
      if(this.searchEnterprise != 'all') {
        search_data.enterprise_id = this.searchEnterprise;
      }
      if(this.searchStudent != 'all') {
        search_data.student_id = this.searchStudent;
      }
      this.getInternRecordList(search_data);
    },
    open_chat_room (student_id) {
      if(this.chat_room) {
        this.chat_room.open(student_id);
      }
    },
  }
}
</script>
<style lang="scss" scoped>
  .search {
    display: flex;
    align-items: center;
    gap: 12px 40px;
    flex-wrap: wrap;
    padding: 8px;
    margin-bottom: 12px;
  }
  .search_block { display: flex; align-items: center; gap: 20px; flex-wrap: wrap; }
  .search label { margin: 0; }
  .search select {
    background: #fff;
    height: 29px;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    outline: none;
  }
</style>
